<div class="w-100">
  <h1 class="mb-0">
    {{ firstName }}
    <span class="text-primary">{{ lastName }}</span>
  </h1>
  <div class="subheading mb-5">
    <a href="mailto:{{ emailId }}">{{ emailId }}</a>
  </div>

  <div class="resume-content">
    <p>
      {{ aboutMe }}
    </p>
  </div>

  <div class="lead mb-3" *ngIf="expertiseList.length > 0">
    My expertise are :
  </div>
  <ul class="fa-ul mb-5">
    <li *ngFor="let item of expertiseList">
      <i class="fa-li fa fa-check"></i>
      {{ item }}
    </li>
  </ul>
  
  <div class="lead social-icons">
    <a
      target="_blank"
      href="https://www.linkedin.com/in/vishal-jaiswal-aa53615b/"
    >
      <i class="fab fa-linkedin-in"></i>
    </a>
    <a target="_blank" href="https://github.com/vishaljaiswal5000">
      <i class="fab fa-github"></i>
    </a>
  </div>
</div>
